import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./header.module.scss";

function Header() {
  const { t } = useTranslation(["common"]);

  return (
    <div className={styles.mainContainer}>
      <Typography color="text.title" variant="h3">
        {t("See how much you save when you switch to the i-mop")}
      </Typography>
      <div>
        <p>
          {t(
            "The i-mop's innovative technology speeds up your cleaning time and reduces your need for cleaning chemicals which means you'll be saving on these costs."
          )}
        </p>
        <p>
          {t(
            "Use the calculator to receive an estimation of the cost you could save."
          )}
        </p>
      </div>
    </div>
  );
}

export default Header;
